import {
  Divider,
  Card,
  Grid,
  Stack,
  Typography,
  Select,
  MenuItem,
  FormControl,
  SelectChangeEvent,
} from '@mui/material';
import { Styles } from '@t2c/shared-fe';
import { AiWorkBenchOutputEnum } from '../../../utils';
import React, { useEffect, useState } from 'react';
import { OutputSection } from './OutputSection';
import { InputSection } from './InputSection';
import { useParams } from 'next/navigation';

export const AIWorkBench = ({ outputType, setOutputType, refetch }) => {
  const handleOutputTypeChange = (event: SelectChangeEvent<AiWorkBenchOutputEnum>) => {
    setOutputType(event.target.value as AiWorkBenchOutputEnum);
  };
  const params = useParams();

  useEffect(() => {
    const generateData = localStorage.getItem('generateIMedia');
    if (!generateData) return;
    try {
      const data = JSON.parse(generateData);
      if (data?.url && data?.complete === true) {
        setOutputType(AiWorkBenchOutputEnum.IMAGE);
      }
    } catch {
      localStorage.removeItem('generateIMedia');
    }
  }, []);

  return (
    <Stack>
      <Grid container spacing={2}>
        <Grid item xs={12} md={7} order={{ xs: 2, md: 1 }}>
          <InputSection outputType={outputType} refetch={refetch} />
        </Grid>
        <Grid item xs={12} md={5} order={{ xs: 1, md: 2 }}>
          <OutputSection outputType={outputType} onOutputTypeChange={handleOutputTypeChange} />
        </Grid>
      </Grid>
    </Stack>
  );
};
